import { PlusIcon, SearchIcon } from '@econsult/econsult-ui/dist/assets';
import React from 'react';
import { AccessibilityFormButton } from 'styles/elements/buttons';
import { ActionPopOutSearchClearButton } from 'styles/elements/popout';
import { TemplateFilter } from './ManagerModal';
import { SidebarButton, SidebarSearch, SidebarTab, SidebarTabButton, SidebarTabs, TextInput } from './styles';

interface TemplateFilterTabsProps {
  filterTabId: string;
  onClickTemplateFilter: (filter: TemplateFilter) => void;
  templateFilters: TemplateFilter[];
}

export const TemplateFilterTabs: React.FC<TemplateFilterTabsProps> = ({
  filterTabId,
  onClickTemplateFilter,
  templateFilters,
}) => (
  <SidebarTabs data-automation="TemplateVisibilityFilters">
    {templateFilters.map(filter => (
      <SidebarTab key={filter.id}>
        <SidebarTabButton
          onClick={() => onClickTemplateFilter(filter)}
          isActive={filterTabId === filter.id}
          id={`templateFilter-${filter.id}`}
          data-automation={`${filter.id}TemplatesFilterButton`}
        >
          {filter.icon}
          <span>{filter.label}</span>
        </SidebarTabButton>
      </SidebarTab>
    ))}
  </SidebarTabs>
);

export const Search = ({
  searchValue,
  onChangeSearch,
  clearSearch,
  idPrefix,
}: {
  searchValue: string;
  onChangeSearch: (event: React.ChangeEvent<HTMLInputElement>) => void;
  clearSearch: () => void;
  idPrefix: string;
}) => (
  <SidebarSearch onSubmit={(event: React.FormEvent<HTMLFormElement>) => event.preventDefault()}>
    <TextInput
      id={`${idPrefix}-templateSearch`}
      label="templateSearch"
      type="text"
      placeholder="Search templates"
      value={searchValue}
      onChange={onChangeSearch}
      labelHidden
      autoFill={false}
      icon={<SearchIcon />}
      endIcon={<ActionPopOutSearchClearButton hasSearched={!!searchValue} onClear={clearSearch} />}
      automationName="TemplateSearchInput"
    />
    <AccessibilityFormButton type="submit" />
  </SidebarSearch>
);

export const NewTemplateButton = ({ onClickNewTemplate }: { onClickNewTemplate: () => void }) => (
  <SidebarButton icon={<PlusIcon />} onClick={onClickNewTemplate} data-automation="NewTemplateButton">
    New template
  </SidebarButton>
);
